// Editar coleção — título e descrição, nunca o identificador.
//
// `id_publico` não aparece como campo, e é o ponto: ele é a URL que o analista
// salvou no projeto de ArcGIS dele. Mostrá-lo editável convidaria a mudá-lo, e
// mudá-lo quebra o projeto do cliente sem aviso — não há redirecionamento que
// resolva, porque ele guardou a string.

import { useState, type ReactNode } from "react";
import type { Colecao } from "../api.js";
import { Gaveta } from "../pecas/basicos.js";

export function EditarColecao({
  colecao,
  aoFechar,
  aoSalvar,
  salvando,
}: {
  colecao: Colecao;
  aoFechar: () => void;
  aoSalvar: (corpo: Record<string, unknown>) => void;
  salvando: boolean;
}): ReactNode {
  const [titulo, setTitulo] = useState(colecao.titulo);
  const [descricao, setDescricao] = useState(colecao.descricao ?? "");

  return (
    <Gaveta titulo={`Editar ${colecao.id_publico}`} subtitulo={colecao.camada} aoFechar={aoFechar}>
      <div className="form-secao">
        <div className="form-secao-titulo">Catálogo</div>
        <div className="campo">
          <label htmlFor="ec-titulo">Título</label>
          <input id="ec-titulo" value={titulo} onChange={(e) => setTitulo(e.target.value)} />
          <div className="campo-ajuda">É o que o cliente vê no catálogo OGC.</div>
        </div>
        <div className="campo">
          <label htmlFor="ec-descricao">Descrição</label>
          <textarea
            id="ec-descricao"
            rows={3}
            value={descricao}
            onChange={(e) => setDescricao(e.target.value)}
          />
        </div>
      </div>

      <div className="form-secao">
        <div className="form-secao-titulo">Endereço</div>
        <code className="mono url-contrato">/ogc/collections/{colecao.id_publico}/items</code>
        <div className="campo-ajuda">
          O identificador público <b>não se altera</b>: é a URL que o cliente salvou no projeto de
          ArcGIS dele. Se precisar de outro endereço, crie outra coleção.
        </div>
      </div>

      <div className="acoes-form">
        <button
          className="btn btn-primario"
          disabled={titulo.trim() === "" || salvando}
          onClick={() => aoSalvar({ titulo: titulo.trim(), descricao: descricao.trim() || null })}
        >
          {salvando ? "Salvando…" : "Salvar"}
        </button>
        <button className="btn" onClick={aoFechar}>
          Cancelar
        </button>
      </div>
    </Gaveta>
  );
}
